/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// "Lite motion" for weak devices: sets <html data-motion="lite">, which stops every decorative
// animation (see GlobalStyle) and the fireworks (see Fireworks.js). The design stays the same;
// only the motion goes.
//   1. Known-weak hardware or Data Saver -> lite immediately.
//   2. Otherwise watch real frame times for 2 seconds after load; if the device can't hold
//      roughly 30 fps, switch to lite.
const LITE_FRAME_MS = 34
const SAMPLE_MS = 2000

const setLite = () => {
  document.documentElement.dataset.motion = "lite"
  window.dispatchEvent(new Event("sba:motion-lite"))
}

// "Idle" pause: animations run while the visitor is engaging (scroll, pointer, touch, keys)
// and for IDLE_MS afterwards; then <html data-idle> pauses all motion (see GlobalStyle,
// Fireworks.js, TextAnimation.js) until the next interaction. A page left open costs ~nothing.
const IDLE_MS = 8000

const trackIdle = () => {
  const root = document.documentElement
  let timer = 0
  const wake = () => {
    if (root.dataset.idle) {
      delete root.dataset.idle
      window.dispatchEvent(new Event("sba:awake"))
    }
    window.clearTimeout(timer)
    timer = window.setTimeout(() => {
      root.dataset.idle = "true"
      window.dispatchEvent(new Event("sba:idle"))
    }, IDLE_MS)
  }
  ;["pointermove", "pointerdown", "scroll", "keydown", "touchstart", "wheel"].forEach(type =>
    window.addEventListener(type, wake, { passive: true })
  )
  wake()
}

export const onClientEntry = () => {
  trackIdle()
  const nav = window.navigator
  const weakHardware =
    (nav.hardwareConcurrency && nav.hardwareConcurrency <= 4) ||
    (nav.deviceMemory && nav.deviceMemory <= 4) ||
    (nav.connection && nav.connection.saveData)
  if (weakHardware) {
    setLite()
    return
  }

  const sample = () => {
    if (document.hidden) return
    let frames = 0
    let first = 0
    const step = now => {
      if (!first) first = now
      frames += 1
      if (now - first < SAMPLE_MS) {
        requestAnimationFrame(step)
      } else if ((now - first) / frames > LITE_FRAME_MS) {
        setLite()
      }
    }
    requestAnimationFrame(step)
  }
  window.addEventListener("load", () => window.setTimeout(sample, 1500), { once: true })
}
